import { Button, Spin, Typography } from 'antd'

// End of an infinite-scroll sparepart list: the sentinel that triggers the next page, plus
// next-page and error feedback. The status row keeps a fixed height while more pages are
// expected, so toggling the spinner never resizes the list at the bottom of the scroll box.
// The status row is `relative` so its absolutely positioned `sr-only` text stays inside the
// scroll box; otherwise it escapes to the modal, overflows the modal wrapper and adds a
// scrollbar that shifts the centered modal sideways while the spinner is shown.
function SparepartListFooter({ sentinelRef, canLoadMore, isFetchingNextPage, isError, onRetry }) {
  const isNextPageExpected = Boolean(canLoadMore || isFetchingNextPage)

  return (
    <>
      <div ref={sentinelRef} className="h-px" aria-hidden="true" />
      {isNextPageExpected ? <NextPageStatus isFetching={isFetchingNextPage} /> : null}
      {isError ? <LoadErrorRow onRetry={onRetry} /> : null}
    </>
  )
}

function NextPageStatus({ isFetching }) {
  return (
    <div role="status" aria-live="polite" className="relative flex h-8 items-center justify-center">
      {isFetching ? (
        <>
          <Spin size="small" />
          <span className="sr-only">Memuat sparepart berikutnya</span>
        </>
      ) : null}
    </div>
  )
}

function LoadErrorRow({ onRetry }) {
  return (
    <div className="flex items-center justify-between gap-2 p-2">
      <Typography.Text type="danger" role="alert">
        Gagal memuat daftar sparepart. Periksa koneksi, lalu coba lagi.
      </Typography.Text>
      <Button size="small" className="rounded-md" onClick={() => onRetry()}>
        Coba lagi
      </Button>
    </div>
  )
}

export default SparepartListFooter
